import React from "react"

import { Typography, useIsMobileDevice } from "@l2r-front/l2r-ui"

import * as Styled from "./RoadAssesmentList.styled"

export const RoadAssesmentList = (props: RoadAssesmentListProps): React.ReactNode => {

    const {
        children,
        listKey,
        title,
    } = props

    const isMobile = useIsMobileDevice()

    return (
        <Styled.Container id={listKey} isMobile={isMobile}>
            {title && <Styled.Title id={`${listKey}-title`}>
                <Typography variant="Desktop & Mobile/Heading/H2">{title}</Typography>
            </Styled.Title>}
            <Styled.ListWrapper>
                <Styled.List>
                    {children}
                </Styled.List>
            </Styled.ListWrapper>
        </Styled.Container>
    )
}

type RoadAssesmentListProps = {
    children: React.ReactNode
    listKey: string
    title: string
}
